import React, { useState } from 'react';
import FormControl from 'olive-react-myoneui/lib/FormControl';
import DropdownCommon from '../DropdownCommon';
import Button from 'olive-react-myoneui/lib/Button';

import { searchIcon, closeIcon, StarIcon, leftArrowLong } from '../../../constants/icons';

const DocFilter = ({
    className,
    searchPlaceholder = "Search by keywords, title or tags",
    dropdownLabel = "All Categories",
    dropdownItems = [],
    onDropdownChange = () => {},
    onSearchChange = () => {},
    onClearSearch = () => {},
    onSortChange,
}) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [activeButton, setActiveButton] = useState('all');
    const [searchSlide, setSearchSlide] = useState();
    const [scrollPosition, setScrollPosition] = useState(0);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        onSearchChange(value);
    };

    const handleClearInput = () => {
        setSearchQuery('');
        onClearSearch();
        document.querySelector('input[aria-label="Search"]').focus();
    };

    const handleSortSelection = (sortType) => {
        setActiveButton(sortType);
        onSortChange(sortType);
    };

    const handleCourseSearchSlide = () => {
        const body = document.body;

        if (searchSlide) {
        body.classList.remove('switched-search-on');
        window.scrollTo(0, scrollPosition);
        } else {
        setScrollPosition(window.scrollY);
        body.classList.add('switched-search-on');
        document.querySelector('.myk__stu-searchbar input[aria-label="Search"]').focus();
        window.scrollTo(0, 0);
        }

        setSearchSlide(!searchSlide);
    }

    return (
        <div className={`${className || ''} myk__stu-dms-filter`}>
            <div className="myk__stu-searchbar search-wrapper-sm">
                <span className="icon">{searchIcon}</span>
                <FormControl 
                  placeholder={searchPlaceholder}
                  aria-label="Search"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <span className="icon-go_back" onClick={handleCourseSearchSlide}>{leftArrowLong}</span>
                <span className="icon-clear" onClick={handleClearInput}>{closeIcon}</span>
            </div>
            <div className="myk__stu-search_filter-mobile">
                <div className="myk__stu-search-wrapper">
                <span className="icon" role="button" onClick={handleCourseSearchSlide}>{searchIcon}</span>
                </div>
            </div>
            <DropdownCommon
                label={dropdownLabel}
                items={dropdownItems}
                onChange={onDropdownChange}
            />
            {onSortChange &&
            <div className="myk__stu-dms-quick-sort">
                <Button
                    variant="primary"
                    className={`btn-round ${activeButton === "all" ? "active" : ""}`}
                    onClick={() => handleSortSelection("all")}
                >
                    All Files
                </Button>
                <Button
                    variant="primary"
                    className={`btn-round d-flex align-items-center justify-content-center gap-1 ${activeButton === "starred" ? "active" : ""}`}
                    onClick={() => handleSortSelection("starred")}
                >
                    {StarIcon} <span>Starred</span>
                </Button>
            </div>
            }
        </div>
    );
};

export default DocFilter;
